// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div#learnpress-gradebook-react {
  padding: 20px 20px 20px 0px;
}
div#learnpress-gradebook-react .breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #e4e4e4;
  border-radius: 2px;
  margin-left: 0;
}
div#learnpress-gradebook-react .breadcrumb > li {
  margin: 0;
}
div#learnpress-gradebook-react .breadcrumb .breadcrumb-item + .breadcrumb-item::before {
  display: inline-block;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  color: #6c757d;
  content: "/";
}
div#learnpress-gradebook-react .breadcrumb a {
  cursor: pointer;
}

.learnpress-gradebook button .components-spinner {
  margin: 0 10px 0 0;
}
.learnpress-gradebook table th.index {
  width: 50px;
}
.learnpress-gradebook table thead th {
  color: #2271b1;
}
.learnpress-gradebook h2.title-head span {
  font-size: 14px;
}
.learnpress-gradebook .wrap-config {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.learnpress-gradebook .wrap-config .export-csv {
  width: 50%;
  display: flex;
  align-items: center;
  column-gap: 20px;
}
.learnpress-gradebook .wrap-config .export-csv input[type=search] {
  min-width: 400px;
}
.learnpress-gradebook .wrap-config .search-screen {
  width: 50%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.learnpress-gradebook .wrap-config .search-screen form#posts-filter {
  display: flex;
  align-items: center;
}
.learnpress-gradebook .chart_sc {
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  text-align: center;
  justify-content: space-between;
  align-items: end;
}
.learnpress-gradebook .chart_sc.chart_sc3 {
  text-align: left;
  justify-content: unset;
  align-items: center;
}
.learnpress-gradebook .chart_sc.chart_sc3 .quiz_detail {
  width: 30%;
}
.learnpress-gradebook .chart_sc.chart_sc3 .detail-chart {
  width: 22%;
}
.learnpress-gradebook .chart_sc .detail-chart {
  width: 45%;
}
.learnpress-gradebook .chart_sc .detail-chart__loading {
  position: relative;
}
.learnpress-gradebook .chart_sc .detail-chart__loading > :not(.components-spinner) {
  opacity: 0.2;
  pointer-events: none;
}
.learnpress-gradebook .chart_sc .detail-chart__loading > .components-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -10px;
  margin-left: -10px;
}
.learnpress-gradebook .chart_sc .detail-chart ul.subsubsub {
  margin-bottom: 20px;
}
.learnpress-gradebook .chart_sc .detail-chart ul.subsubsub li {
  margin-right: 5px;
}
.learnpress-gradebook .chart_sc .detail-chart .ct-chart {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.learnpress-gradebook .chart_sc .detail-chart .ct-chart .ct-left {
  width: 55%;
}
.learnpress-gradebook .chart_sc .detail-chart .ct-chart .ct-right {
  width: 45%;
  text-align: left;
}
.learnpress-gradebook .chart_sc .title-chart {
  display: flex;
  align-items: center;
}
.learnpress-gradebook .chart_sc .title-chart p {
  font-style: italic;
  font-size: 14px;
  padding-left: 10px;
}
.learnpress-gradebook .chart_sc .title-chart.center {
  justify-content: center;
}
.learnpress-gradebook .number_retake {
  display: inline;
  position: relative;
}
.learnpress-gradebook .number_retake span.count_retake {
  padding: 8px;
  cursor: pointer;
}
.learnpress-gradebook span.lp-gradebook-item__title {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
  width: 100%;
}
.learnpress-gradebook .lp-skeleton-animation li {
  width: 100%;
  height: 30px;
  border-radius: "4px";
}
.learnpress-gradebook .pagination {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 0.25rem;
  margin-top: 20px;
}
.learnpress-gradebook .pagination li {
  position: relative;
  margin-left: -1px;
  line-height: 1.25;
  color: #2271b1;
  background-color: #fff;
  border: 1px solid #dee2e6;
  cursor: pointer;
}
.learnpress-gradebook .pagination li.active {
  z-index: 1;
  color: #fff;
  background-color: #2271b1;
  border-color: #2271b1;
}
.learnpress-gradebook .pagination li.active a {
  color: white;
}
.learnpress-gradebook .pagination li a {
  display: flex;
  width: 33px;
  height: 33px;
  justify-content: center;
  align-items: center;
}

.wp-list-table.lp-gradebook-spinner {
  position: relative;
}
.wp-list-table.lp-gradebook-spinner tbody {
  opacity: 0.2;
}
.wp-list-table.lp-gradebook-spinner > .components-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
}

.lp-gradebook-overlay {
  background-color: rgba(0, 0, 0, 0.05);
}
.lp-gradebook-overlay .components-modal__frame {
  box-shadow: 0 0 2px 0 #ccc;
}

.lp-gradebook_retake {
  width: 150px;
}
.lp-gradebook_retake .lp-gradebook_retake_detail {
  display: flex;
  justify-content: space-between;
  padding: 10px 15px;
  cursor: pointer;
  font-size: 13px;
  font-weight: normal;
  background-color: #f6f7f7;
}
.lp-gradebook_retake .lp-gradebook_retake_detail:nth-child(2n+1) {
  background-color: #fff;
}

.components-dropdown__content.lp-gradebook_my_popover_content .components-popover__content {
  box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22);
  border-radius: 5px;
}
.components-dropdown__content.lp-gradebook_my_popover_content .components-popover__content > div {
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./assets/src/scss/index.scss"],"names":[],"mappings":"AAAA;EACC,2BAAA;AACD;AACC;EACC,aAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AACF;AACE;EACC,SAAA;AACH;AAEE;EACC,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,cAAA;EACA,YAAA;AAAH;AAEE;EACC,eAAA;AAAH;;AAOE;EACC,kBAAA;AAJH;AASE;EACC,WAAA;AAPH;AAUG;EACC,cAAA;AARJ;AAcE;EACC,eAAA;AAZH;AAeC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAbF;AAeE;EACC,UAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AAbH;AAeG;EACC,gBAAA;AAbJ;AAgBE;EACC,UAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AAdH;AAgBG;EACC,aAAA;EACA,mBAAA;AAdJ;AAmBC;EACC,WAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,gBAAA;AAjBF;AAmBE;EACC,gBAAA;EACA,sBAAA;EACA,mBAAA;AAjBH;AAmBG;EACC,UAAA;AAjBJ;AAmBG;EACC,UAAA;AAjBJ;AAoBE;EACC,UAAA;AAlBH;AAoBG;EACC,kBAAA;AAlBJ;AAoBI;EACC,YAAA;EACA,oBAAA;AAlBL;AAqBI;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;AAnBL;AAuBG;EACC,mBAAA;AArBJ;AAsBI;EACC,iBAAA;AApBL;AAwBG;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAtBJ;AAwBI;EACC,UAAA;AAtBL;AAwBI;EACC,UAAA;EACA,gBAAA;AAtBL;AA0BE;EACC,aAAA;EACA,mBAAA;AAxBH;AA0BG;EACC,kBAAA;EACA,eAAA;EACA,kBAAA;AAxBJ;AA0BG;EACC,uBAAA;AAxBJ;AA6BC;EACC,eAAA;EACA,kBAAA;AA3BF;AA6BE;EACC,YAAA;EACA,eAAA;AA3BH;AA8BC;EACC,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;AA5BF;AAgCE;EACC,WAAA;EACA,YAAA;EACA,oBAAA;AA9BH;AAiCC;EACC,oBAAA;EACA,oBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;AA/BF;AAiCE;EACC,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;AA/BH;AAiCG;EACC,UAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;AA/BJ;AAgCI;EACC,YAAA;AA9BL;AAiCG;EACC,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AA/BJ;;AAsCC;EACC,kBAAA;AAnCF;AAqCE;EACC,YAAA;AAnCH;AAsCE;EACC,kBAAA;EACA,QAAA;EACA,SAAA;AApCH;;AAyCA;EACC,qCAAA;AAtCD;AAuCC;EACC,0BAAA;AArCF;;AAyCA;EACC,YAAA;AAtCD;AAuCC;EACC,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;AArCF;AAuCE;EACC,sBAAA;AArCH;;AA0CC;EACC,2EAAA;EACA,kBAAA;AAvCF;AAwCE;EACC,UAAA;AAtCH","sourcesContent":["div#learnpress-gradebook-react {\n\tpadding: 20px 20px 20px 0px;\n\n\t.breadcrumb {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tpadding: 0.75rem 1rem;\n\t\tmargin-bottom: 1rem;\n\t\tlist-style: none;\n\t\tbackground-color: #e4e4e4;\n\t\tborder-radius: 2px;\n\t\tmargin-left: 0;\n\n\t\t>li{\n\t\t\tmargin: 0;\n\t\t}\n\n\t\t.breadcrumb-item + .breadcrumb-item::before {\n\t\t\tdisplay: inline-block;\n\t\t\tpadding-right: 0.5rem;\n\t\t\tpadding-left: 0.5rem;\n\t\t\tcolor: #6c757d;\n\t\t\tcontent: \"/\";\n\t\t}\n\t\ta {\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n}\n\n.learnpress-gradebook {\n\tbutton{\n\t\t.components-spinner{\n\t\t\tmargin: 0 10px 0 0;\n\t\t}\n\t}\n\n\ttable {\n\t\tth.index {\n\t\t\twidth: 50px;\n\t\t}\n\t\tthead {\n\t\t\tth {\n\t\t\t\tcolor: #2271b1;\n\t\t\t}\n\t\t}\n\t}\n\n\th2.title-head{\n\t\tspan{\n\t\t\tfont-size: 14px;\n\t\t}\n\t}\n\t.wrap-config {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tmargin-bottom: 20px;\n\n\t\t.export-csv {\n\t\t\twidth: 50%;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tcolumn-gap: 20px;\n\n\t\t\tinput[type=\"search\"]{\n\t\t\t\tmin-width: 400px;\n\t\t\t}\n\t\t}\n\t\t.search-screen {\n\t\t\twidth: 50%;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: flex-end;\n\t\t\talign-items: center;\n\n\t\t\tform#posts-filter {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t}\n\t\t}\n\t}\n\n\t.chart_sc {\n\t\twidth: 100%;\n\t\tmargin-bottom: 20px;\n\t\tdisplay: flex;\n\t\ttext-align: center;\n\t\tjustify-content: space-between;\n\t\talign-items: end;\n\n\t\t&.chart_sc3 {\n\t\t\ttext-align: left;\n\t\t\tjustify-content: unset;\n\t\t\talign-items: center;\n\n\t\t\t.quiz_detail {\n\t\t\t\twidth: 30%;\n\t\t\t}\n\t\t\t.detail-chart {\n\t\t\t\twidth: 22%;\n\t\t\t}\n\t\t}\n\t\t.detail-chart {\n\t\t\twidth: 45%;\n\n\t\t\t&__loading{\n\t\t\t\tposition:relative;\n\n\t\t\t\t>:not(.components-spinner){\n\t\t\t\t\topacity: .2;\n\t\t\t\t\tpointer-events: none;\n\t\t\t\t}\n\n\t\t\t\t>.components-spinner{\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\tleft: 50%;\n\t\t\t\t\tmargin-top: -10px;\n\t\t\t\t\tmargin-left: -10px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tul.subsubsub {\n\t\t\t\tmargin-bottom: 20px;\n\t\t\t\tli {\n\t\t\t\t\tmargin-right: 5px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.ct-chart {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\talign-items: center;\n\n\t\t\t\t.ct-left {\n\t\t\t\t\twidth: 55%;\n\t\t\t\t}\n\t\t\t\t.ct-right {\n\t\t\t\t\twidth: 45%;\n\t\t\t\t\ttext-align: left;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.title-chart {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\n\t\t\tp {\n\t\t\t\tfont-style: italic;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tpadding-left: 10px;\n\t\t\t}\n\t\t\t&.center {\n\t\t\t\tjustify-content: center;\n\t\t\t}\n\t\t}\n\t}\n\n\t.number_retake {\n\t\tdisplay: inline;\n\t\tposition: relative;\n\n\t\tspan.count_retake {\n\t\t\tpadding: 8px;\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n\tspan.lp-gradebook-item__title{\n\t\ttext-overflow: ellipsis;\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\tdisplay: inline-block;\n\t\twidth: 100%;\n\t}\n\n\t.lp-skeleton-animation {\n\t\tli {\n\t\t\twidth: 100%;\n\t\t\theight: 30px;\n\t\t\tborder-radius: \"4px\";\n\t\t}\n\t}\n\t.pagination {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\tpadding-left: 0;\n\t\tlist-style: none;\n\t\tborder-radius: 0.25rem;\n\t\tmargin-top: 20px;\n\n\t\tli {\n\t\t\tposition: relative;\n\t\t\tmargin-left: -1px;\n\t\t\tline-height: 1.25;\n\t\t\tcolor: #2271b1;\n\t\t\tbackground-color: #fff;\n\t\t\tborder: 1px solid #dee2e6;\n\t\t\tcursor: pointer;\n\n\t\t\t&.active {\n\t\t\t\tz-index: 1;\n\t\t\t\tcolor: #fff;\n\t\t\t\tbackground-color: #2271b1;\n\t\t\t\tborder-color: #2271b1;\n\t\t\t\ta {\n\t\t\t\t\tcolor: white;\n\t\t\t\t}\n\t\t\t}\n\t\t\ta {\n\t\t\t\tdisplay: flex;\n\t\t\t\twidth: 33px;\n\t\t\t\theight: 33px;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.wp-list-table{\n\t&.lp-gradebook-spinner {\n\t\tposition: relative;\n\n\t\ttbody{\n\t\t\topacity: 0.2;\n\t\t}\n\n\t\t>.components-spinner{\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 50%;\n\t\t}\n\t}\n}\n\n.lp-gradebook-overlay{\n\tbackground-color: rgba(0,0,0,.05);\n\t.components-modal__frame{\n\t\tbox-shadow: 0 0 2px 0 #ccc;\n\t}\n}\n\n.lp-gradebook_retake {\n\twidth: 150px;\n\t.lp-gradebook_retake_detail{\n\t\tdisplay:flex;\n\t\tjustify-content: space-between;\n\t\tpadding:10px 15px;\n\t\tcursor: pointer;\n\t\tfont-size: 13px;\n\t\tfont-weight: normal;\n\t\tbackground-color:#f6f7f7;\n\n\t\t&:nth-child(2n+1){\n\t\t\tbackground-color:#fff;\n\t\t}\n\t}\n}\n.components-dropdown__content.lp-gradebook_my_popover_content{\n\t.components-popover__content {\n\t\tbox-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);\n\t\tborder-radius: 5px;\n\t\t> div {\n\t\t\tpadding:0;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
